import { Routes } from '@/config/routes';
import { absoluteUrl } from '@/lib/seo/canonical-url';

export type ItemListProduct = {
  name?: string | null;
  slug?: string | null;
  sku?: string | number | null;
};

/**
 * schema.org ItemList of the products rendered on a listing page. Returns
 * null when no product has the fields needed to build its URL.
 */
export function buildProductItemList(
  listId: string,
  products: readonly ItemListProduct[] | undefined,
) {
  const items = (products ?? []).flatMap((product) =>
    product?.slug && product?.sku && product?.name
      ? [
          {
            url: absoluteUrl(
              Routes.product(String(product.slug), String(product.sku)),
            ),
            name: String(product.name),
          },
        ]
      : [],
  );

  if (items.length === 0) return null;

  return {
    '@type': 'ItemList',
    '@id': listId,
    numberOfItems: items.length,
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: item.url,
      name: item.name,
    })),
  };
}
